import { createPortal } from 'react-dom'
import { IconClose } from '../../../assets/icons'
import './index.scss'

export default function BaseBottomSheetPopup({ open = false, onClose = () => {}, title = '', children, className = '' }) {
  if (!open || typeof document === 'undefined') return null

  return createPortal(
    <div className={`BaseBottomSheetPopup ${className}`.trim()} role="dialog" aria-modal="true" aria-labelledby="BaseBottomSheetPopup_title">
      <button type="button" className="BaseBottomSheetPopup_overlay" aria-label="Đóng hộp thoại" onClick={onClose}></button>

      <div className="BaseBottomSheetPopup_sheet">
        <div className="BaseBottomSheetPopup_header">
          <div className="BaseBottomSheetPopup_title" id="BaseBottomSheetPopup_title">
            {title}
          </div>

          <button type="button" className="BaseBottomSheetPopup_close" aria-label="Đóng hộp thoại" onClick={onClose}>
            <IconClose />
          </button>
        </div>

        <div className="BaseBottomSheetPopup_body">{children}</div>
      </div>
    </div>,
    document.body
  )
}
